/*
    This module is automatically loaded wherever app.js is included.

    Because app.js is included with "defer", it will execute *after* the DOM is ready, but *before* DOMContentLoaded
    fires, and hence before any other modules the current page loads.

    Do not delay execution with $.ready(...) or $(() => { ... }) in this file, unless you want something to run *after*
    all the modules loaded by the current page.
 */
import 'dawa-autocomplete2';
import * as DKFDS from 'dkfds';
import $ from 'jquery';
import moment from 'moment';
import 'moment/locale/da';
import 'whatwg-fetch';
import { setupSessionTimer } from '../session-handling';

moment.locale('da');

function setLastValidValue() {
    $(this).data('lastValidValue', $(this).val());
}

function floatInputHandler(event) {
    const field = $(event.target);

    if (event.key === ".") {
        field.val(field.val().replace(/\./g, ','));
    }

    const pattern = /^(\d*)(?:,(\d*))?$/;
    const value = field.val();
    const result = pattern.exec(value);

    if (result) {
        const precision = field.data('precision');
        const scale = field.data('scale');
        if (precision === undefined || result[1].length <= precision - (scale || 0)) {
            if (scale === undefined || result[2] === undefined || result[2].length <= scale) {
                // Value is valid
                field.data('lastValidValue', value);
                return;
            }
        }
    }

    field.val(field.data('lastValidValue'));
}

function moveModals() {
    // If there is a <form> element at the root of <body>, use that as the modal container
    // Otherwise generate a new modal container at the root of <body>
    const form = document.querySelector('body > form');
    const container = form || document.body.appendChild(document.createElement('div'));
    container.classList.add('fds-modal-container');

    // Move all modals on page to the modal container
    container.append(...document.querySelectorAll('.fds-modal'));
}

moveModals();

DKFDS.init();

// Temporary fix for https://github.com/detfaellesdesignsystem/dkfds-components/issues/254
document.querySelectorAll('[data-maxlength] .form-input').forEach(input => {
    input.dispatchEvent(new Event('keyup'));
});

setupSessionTimer();

$(document).on('change', 'input[type="file"]', function () {
    // fileupload magic
    const input = $(this);
    const numFiles = input.get(0).files ? input.get(0).files.length : 1;
    const label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
    input.trigger('rov:fileselect', [numFiles, label]);
});

// Restrict input in <input type=text class=float data-precision=<max total digits> data-scale=<max fractional digits> />
$('.float')
    .each(setLastValidValue)
    .on('keyup', floatInputHandler);

$('.auto-submit').on('change', function (event) {
    $(event.target).closest('form')
        .attr('enctype', 'application/x-www-form-urlencoded')
        .submit();
});

$('input:checkbox.applicantNoClick').on('click keypress', function (e) {
    e.preventDefault();
    e.stopPropagation();
});

// Prevent 'Enter' in text fields in modals from triggering a submit
$('.fds-modal input[type="text"]').on('keypress', function(event) {
    if (event.which === 13) {
        event.preventDefault();
    }
});
